import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63a9cf34"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pin-angle-fill fs-3" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  class: "d-none d-lg-flex flex-column align-items-center flex-column-auto py-4 aside-logo",
  id: "kt_aside_logo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { id: "kt_aside_logo_toggle" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "aside-menu flex-column-fluid",
  style: {"overflow-y":"auto","max-height":"calc(100vh - 150px)"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "aside-footer flex-column-auto pt-5 pb-7 px-5",
  id: "kt_aside_footer"
}, null, -1))
const _hoisted_10 = { class: "d-flex flex-column align-items-center justify-content-center py-4" }
const _hoisted_11 = { style: {"color":"var(--cor_icones_1)","font-size":"1rem"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--cor_icones_1)","font-size":".9rem"} }, " Versão ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    style: {"z-index":"110"},
    class: _normalizeClass(["aside aside-hoverable fundo-rodape", [
      _ctx.asideTheme === 'light' && 'aside-light',
      _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle",
    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showIcon = true)),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showIcon = false))
  }, [
    _createElementVNode("div", {
      id: "kt_aside_toggle",
      class: _normalizeClass(["btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle align-logo-aside", { show: _ctx.showIcon }]),
      "data-kt-toggle": "true",
      "data-kt-toggle-state": "active",
      "data-kt-toggle-target": "body",
      "data-kt-toggle-name": "aside-minimize"
    }, _hoisted_2, 2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.asideTheme === 'dark')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.rota())),
            href: "#"
          }, [
            _createElementVNode("img", {
              alt: "Logo",
              src: _ctx.darkLogo,
              class: "h-55px"
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      (_ctx.asideTheme === 'light')
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rota())),
            href: "#"
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("img", {
                id: "kt_aside_logo_img_i",
                src: _ctx.pontueiLogoI,
                alt: "Pontuei"
              }, null, 8, _hoisted_6),
              _createElementVNode("img", {
                id: "kt_aside_logo_img_ii",
                src: _ctx.pontueiLogoII,
                alt: "Pontuei"
              }, null, 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_KTMenu)
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.appVersion), 1),
      _hoisted_12
    ])
  ], 34))
}